"use strict";

export default function accordionItem(id) {
    return {
        id,
        isOpen: false,
        toggle() {
            if (!this.isOpen) {
                window.dispatchEvent(new CustomEvent('close-others', {detail: {except: this.id}}));
            }
            this.isOpen = !this.isOpen;
        },
        init() {
            window.addEventListener('close-others', (e) => {
                if (e.detail.except !== this.id) {
                    this.isOpen = false;
                }
            });
        }
    }
}
